import { UploadData } from 'records/UploadData';
import { RawUploadResponse, UploadResponse } from 'records/UploadResponse';
import GQLRequest from 'utils/GQLRequest';

interface RawFileResp {
  fileid: string;
  projectid: string;
  filename: string;
  filesize: number;
  category: string;
  extension: string;
  uploadStatus: string;
}

export interface FileResp {
  fileid: string;
  projectid: string;
  filename: string;
  filesize: number;
  category: string;
  extension: string;
  uploadStatus: string;
  url: string;
}

// input UploadData {
//   projectid: String!
//   filename: String!
//   category: String!
//   extension: String!
//   filesize: Int!
// }

// type UploadResponse {
//   fileid: String!
//   signedurl: String!
// }

// File => {
//   name: "clothesline_1.jpg"
//   lastModified: 1568752168032
//   lastModifiedDate: Tue Sep 17 2019 13:29:28 GMT-0700 (Pacific Daylight Time) {}
//   webkitRelativePath: ""
//   size: 92862
//   type: "image/jpeg"
// }

// const mimeTypeExtensions = {
//   'image/jpeg': '.jpg',
//   'image/svg+xml': '.svg',
//   'image/png': '.png',
//   'application/pdf': '.pdf',
//   'image/bmp': '.bmp',
// };

// beginUpload(input: UploadData): UploadResponse!
// completeUpload(input: ProjectFile): boolean!

export const completeUpload = async (
  projectid: string,
  fileid: string
): Promise<boolean> => {
  try {
    const resp = await new GQLRequest()
      .query(
        `
          mutation CompleteUpload($projectFile: ProjectFile) {
            completeUpload(input: $projectFile)
          }
        `
      )
      .variables({ projectFile: { fileid, projectid } })
      .json<{ completeUpload: boolean }>();

    return resp.completeUpload;
  } catch (err) {
    console.log('completeUpload: ', err);

    throw err;
  }
};

export const beginUpload = async (
  uploadData: UploadData
): Promise<UploadResponse> => {
  const resp = await new GQLRequest()
    .query(
      `
        mutation BeginUpload($input: UploadData) {
          beginUpload(input: $input) {
            fileid
            signedurl
          }
        }
        `
    )
    .variables({ input: uploadData.serialize() })
    .json<{ beginUpload: RawUploadResponse }>();

  return UploadResponse.deserialize(resp.beginUpload);
};

export const uploadFile = async (uploadData: UploadData): Promise<string> => {
  try {
    const {
      beginUpload: { fileid, signedurl },
    } = await new GQLRequest()
      .query(
        `
          mutation BeginUpload($input: UploadData) {
            beginUpload(input: $input) {
              fileid
              signedurl
            }
          }
          `
      )
      .variables({ input: uploadData.serialize() })
      .json<{ beginUpload: RawUploadResponse }>();

    const uploadResp = await fetch(signedurl, {
      method: 'PUT',
      body: uploadData.file,
    });

    if (uploadResp.ok) {
      const uploadComplete = await completeUpload(uploadData.projectid, fileid);

      console.log('uploadComplete??', uploadComplete);

      return fileid;
    }

    return '';
  } catch (err) {
    throw new Error(`Unable to upload file: ${err}`);
  }
};

export const getFile = async (
  projectid: string,
  fileid: string
): Promise<FileResp> => {
  try {
    const resp = await new GQLRequest()
      .query(
        `
        query FileUrl($projectFile: ProjectFile) {
          fileUrl(input: $projectFile) {
            file {
              fileid
              projectid
              filename
              filesize
              category
              extension
              uploadStatus
            }
            url
          }
        }
        `
      )
      .variables({ projectFile: { fileid, projectid } })
      .json<{ fileUrl: { file: RawFileResp; url: string } }>();

    return {
      ...resp.fileUrl.file,
      url: resp.fileUrl.url,
    };

    // return resp.fileUrl;
  } catch (err) {
    console.log('getFile', err);

    throw err;
  }
};

export default {
  completeUpload,
  getFile,
};
